export const companyName = 'Acme Innovations Ltd'

export const adminUser = { name: 'Chidi', role: 'Super Admin' }
export const staffUser = { name: 'Tunde', role: 'Staff' }

export const kpis = [
  { id: 'income', label: 'Income', value: 45200000, delta: 12 },
  { id: 'expenses', label: 'Expenses', value: 32100000, delta: 5 },
  { id: 'profit', label: 'Profit', value: 13100000, delta: 28 },
]

export const recentTransactions = [
  { id: 'TXN-1042', date: '2026-01-14', description: 'Client Invoice — Orbit Logistics', amount: 4200000, status: 'Completed' },
  { id: 'TXN-1041', date: '2026-01-13', description: 'Office Rent — January', amount: -1500000, status: 'Completed' },
  { id: 'TXN-1040', date: '2026-01-12', description: 'Cloud Infrastructure — AWS', amount: -320000, status: 'Pending' },
  { id: 'TXN-1039', date: '2026-01-06', description: 'Consulting Retainer — Halan Group', amount: 2800000, status: 'Completed' },
  { id: 'TXN-1038', date: '2026-01-09', description: 'Staff Payroll — Q1 Run 1', amount: -5400000, status: 'Completed' },
  { id: 'TXN-1037', date: '2026-01-05', description: 'Software Licenses — Adobe + Slack', amount: -89000, status: 'Completed' },
  { id: 'TXN-1036', date: '2026-01-04', description: 'Product Sales — Q4 Batch', amount: 6750000, status: 'Completed' },
  { id: 'TXN-1035', date: '2026-01-03', description: 'Legal Fees — Contract Review', amount: -450000, status: 'Completed' },
  { id: 'TXN-1034', date: '2025-12-28', description: 'Investment Income — Treasury', amount: 1200000, status: 'Completed' },
  { id: 'TXN-1033', date: '2025-12-27', description: 'Marketing — Google Ads', amount: -680000, status: 'Completed' },
  { id: 'TXN-1032', date: '2025-12-22', description: 'Client Invoice — Meridian Partners', amount: 5100000, status: 'Completed' },
  { id: 'TXN-1031', date: '2025-12-20', description: 'Office Supplies — Stationery', amount: -75000, status: 'Completed' },
  { id: 'TXN-1030', date: '2025-12-18', description: 'Insurance Premium — Q4', amount: -320000, status: 'Completed' },
  { id: 'TXN-1029', date: '2025-12-15', description: 'Consulting Retainer — Halan Group', amount: 2800000, status: 'Completed' },
  { id: 'TXN-1028', date: '2025-12-14', description: 'Staff Payroll — Q4 Run 3', amount: -5400000, status: 'Completed' },
  { id: 'TXN-1027', date: '2025-12-10', description: 'Product Sales — November Batch', amount: 6200000, status: 'Completed' },
  { id: 'TXN-1026', date: '2025-12-08', description: 'Travel — Client Visit Abuja', amount: -280000, status: 'Completed' },
  { id: 'TXN-1025', date: '2025-12-05', description: 'SaaS Subscription — CRM Platform', amount: -145000, status: 'Completed' },
  { id: 'TXN-1024', date: '2025-11-30', description: 'Client Invoice — Stellar Dynamics', amount: 3900000, status: 'Completed' },
  { id: 'TXN-1023', date: '2025-11-28', description: 'Office Rent — December', amount: -1500000, status: 'Completed' },
  { id: 'TXN-1022', date: '2025-11-25', description: 'Bank Charges — Q4', amount: -45000, status: 'Completed' },
  { id: 'TXN-1021', date: '2025-11-20', description: 'Product Sales — October Batch', amount: 5800000, status: 'Completed' },
  { id: 'TXN-1020', date: '2025-11-18', description: 'Professional Services — Audit Prep', amount: -380000, status: 'Completed' },
  { id: 'TXN-1019', date: '2025-11-15', description: 'Staff Payroll — Q4 Run 2', amount: -5400000, status: 'Completed' },
]

export const staffTransactions = [
  { id: 'TXN-118', date: '2026-01-14', description: 'Fuel & Logistics', amount: 85000, type: 'Income' },
  { id: 'TXN-117', date: '2026-01-12', description: 'Software Subscription', amount: -24000, type: 'Expense' },
  { id: 'TXN-116', date: '2026-01-06', description: 'Client Reimbursement', amount: 120000, type: 'Income' },
]

export const categories = [
  'Sales Revenue',
  'Consulting',
  'Salaries & Wages',
  'Rent',
  'Utilities',
  'Software',
  'Logistics',
  'Other',
]

// Default Clean-Slate Legal Compliance Summary
export const legalCompliance = [
  { id: 'rc_num', label: 'CAC / RC Number', value: 'Unverified', status: 'warn' },
  { id: 'tin', label: 'TIN Letter / Tax Identity', value: 'Unverified', status: 'warn' },
  { id: 'scuml', label: 'SCUML Certificate', value: 'Pending Upload', status: 'warn' },
  { id: 'memart', label: 'MEMART / Incorporation Docs', value: 'Missing', status: 'warn' },
  { id: 'founder_agmt', label: 'Founders Agreement', value: 'Missing', status: 'warn' },
]

export const auditLogs = [
  {
    id: '1',
    timestamp: '2026-01-14T09:32:11Z',
    actor: 'Chidi Okafor',
    action: 'transaction.create',
    entity: 'TXN-1042',
    summary: 'Created income transaction — Orbit Logistics invoice',
    old_data: null,
    new_data: { id: 'TXN-1042', type: 'income', amount: 4200000, description: 'Client Invoice — Orbit Logistics', status: 'Completed' },
    hash: '0x8af3c1d9',
    prevHash: '0x2b7e0a44',
  },
  {
    id: '2',
    timestamp: '2026-01-13T17:08:45Z',
    actor: 'Tunde Bakare',
    action: 'transaction.create',
    entity: 'TXN-1041',
    summary: 'Recorded expense — Office Rent January',
    old_data: null,
    new_data: { id: 'TXN-1041', type: 'expense', amount: -1500000, description: 'Office Rent — January', status: 'Completed' },
    hash: '0x2b7e0a44',
    prevHash: '0x91c50f7a',
  },
  {
    id: '3',
    timestamp: '2026-01-12T14:21:03Z',
    actor: 'Chidi Okafor',
    action: 'compliance.upload',
    entity: 'DOC-CAC-2024',
    summary: 'Uploaded CAC Certificate',
    old_data: { status: 'missing' },
    new_data: { docType: 'CAC Certificate', fileName: 'cac-cert-2024.pdf', status: 'verified', uploadedAt: '2026-01-12T14:21:03Z' },
    hash: '0x91c50f7a',
    prevHash: '0x4d8a2e6b',
  },
  {
    id: '4',
    timestamp: '2026-01-10T11:47:29Z',
    actor: 'System',
    action: 'token.generate',
    entity: 'INV-TOK-0091',
    summary: 'Generated investor access token (time-limited)',
    old_data: null,
    new_data: { tokenId: 'INV-TOK-0091', scope: 'view_financials', expiresAt: '2026-02-10T00:00:00Z', recipient: 'investor@vc.com' },
    hash: '0x4d8a2e6b',
    prevHash: '0x0a1f3c5e',
  },
  {
    id: '5',
    timestamp: '2026-01-09T08:15:52Z',
    actor: 'Chidi Okafor',
    action: 'transaction.update',
    entity: 'TXN-1038',
    summary: 'Marked payroll transaction as Completed',
    old_data: { id: 'TXN-1038', status: 'Pending' },
    new_data: { id: 'TXN-1038', status: 'Completed', clearedAt: '2026-01-09T08:15:52Z' },
    hash: '0x0a1f3c3e',
    prevHash: '0x00000000',
  },
]

export const documentSet = [
  { id: 'cac', label: 'CAC Certificate', status: 'uploaded', fileName: 'cac-cert-2024.pdf' },
  { id: 'memart', label: 'Memorandum & Articles', status: 'uploaded', fileName: 'memart-final.pdf' },
  { id: 'tin', label: 'TIN Certificate', status: 'uploaded', fileName: 'tin-cert.pdf' },
  { id: 'vat', label: 'VAT Registration', status: 'uploaded', fileName: 'vat-reg-NG.pdf' },
  { id: 'scrt', label: 'Shareholders Register', status: 'uploaded', fileName: 'shareholders.xlsx' },
  { id: 'dirreg', label: 'Directors Register', status: 'missing', fileName: null },
  { id: 'audited', label: 'Audited Financials', status: 'uploaded', fileName: 'audited-2024.pdf' },
  { id: 'annual', label: 'Annual Return Filing', status: 'pending', fileName: null },
  { id: 'board', label: 'Board Resolution', status: 'uploaded', fileName: 'board-res-2025.pdf' },
  { id: 'coi', label: 'Certificate of Incorporation', status: 'uploaded', fileName: 'coi.pdf' },
  { id: 'status', label: 'Status Report', status: 'missing', fileName: null },
  { id: 'taxclear', label: 'Tax Clearance Certificate', status: 'uploaded', fileName: 'tax-clear-2025.pdf' },
  { id: 'bankstmt', label: 'Bank Statement (6mo)', status: 'uploaded', fileName: 'bank-2025H2.pdf' },
  { id: 'utility', label: 'Proof of Address', status: 'uploaded', fileName: 'utility-bill.pdf' },
]

export const activeTokens = []

export const complianceBreakdown = {
  score: 0,
  grade: 'Not Assessed',
  tiers: [
    { id: 'foundation', label: 'Foundation', pct: 0 },
    { id: 'operational', label: 'Operational', pct: 0 },
    { id: 'institutional', label: 'Institutional', pct: 0 },
  ],
}

export const demoComplianceBreakdown = {
  score: 94,
  grade: 'Venture-Grade',
  tiers: [
    { id: 'foundation', label: 'Foundation', pct: 100 },
    { id: 'operational', label: 'Operational', pct: 92 },
    { id: 'institutional', label: 'Institutional', pct: 90 },
  ],
}

export const demoLegalCompliance = [
  { id: 'rc', label: 'RC Number', value: 'RC1234567', status: 'ok' },
  { id: 'tin', label: 'TIN', value: '01234567-0001', status: 'ok' },
  { id: 'vat', label: 'VAT Registered', value: 'NG0123456789', status: 'ok' },
  { id: 'return', label: 'Annual Return', value: 'Filed: Jan 02, 2026', status: 'ok' },
  { id: 'cac', label: 'CAC Certificate Uploaded', value: 'Verified', status: 'ok' },
]

export const docCategories = [
  'Tax Clearance',
  'CAC Filing',
  'TIN Certificate',
  'VAT Registration',
  'Bank Statement',
  'Audited Financials',
  'Board Resolution',
  'Shareholders Register',
  'IP Assignment Agreement',
  'Founder Agreement',
  'Cap Table',
  'Other',
]

// Structural Governance Blueprint (24+ Documents Across 5 Categories)
export const governanceDocs = [
  // Category 1: Corporate & Structure
  { id: 'cac-cert', label: 'CAC Incorporation Certificate', tier: 1, status: 'missing', critical: true },
  { id: 'memart', label: 'MEMART (Articles of Association)', tier: 1, status: 'missing', critical: true },
  { id: 'status-report', label: 'CAC Status Report / Form CAC 1.1', tier: 1, status: 'missing', critical: false },
  { id: 'share-cert', label: 'Share Certificates Issued', tier: 1, status: 'missing', critical: false },
  { id: 'commencement', label: 'Notice of Commencement of Business', tier: 1, status: 'missing', critical: false },

  // Category 2: Core Financials & Tax
  { id: 'tin-letter', label: 'TIN Designation Letter', tier: 2, status: 'missing', critical: true },
  { id: 'scuml-cert', label: 'SCUML Clearance Certificate', tier: 2, status: 'missing', critical: true },
  { id: 'vat-reg', label: 'VAT Registration Certificate', tier: 2, status: 'missing', critical: false },
  { id: 'audit-2025', label: 'Audited Financial Statements', tier: 2, status: 'missing', critical: false },
  { id: 'tax-clearance', label: 'Tax Clearance Certificate (TCC)', tier: 2, status: 'missing', critical: false },

  // Category 3: Team & Human Capital
  { id: 'founder-agmt', label: 'Founders Accord & Reverse Vesting', tier: 3, status: 'missing', critical: true },
  { id: 'ip-assign', label: 'IP Assignment & Proprietary Inventions', tier: 3, status: 'missing', critical: true },
  { id: 'emp-contract', label: 'Standard Employment Agreement Template', tier: 3, status: 'missing', critical: false },
  { id: 'pencom', label: 'PenCom Compliance Certificate', tier: 3, status: 'missing', critical: false },
  { id: 'itf-cert', label: 'ITF Compliance Certificate', tier: 3, status: 'missing', critical: false },

  // Category 4: Risk, Assets & Governance
  { id: 'board-res', label: 'Board Resolutions Log', tier: 4, status: 'missing', critical: false },
  { id: 'ndas', label: 'Mutual & Unilateral NDA Templates', tier: 4, status: 'missing', critical: false },
  { id: 'data-privacy', label: 'NDPR / Data Protection Privacy Policy', tier: 4, status: 'missing', critical: false },
  { id: 'insurance', label: 'Keyperson / Commercial Liability Policy', tier: 4, status: 'missing', critical: false },

  // Category 5: Legal & Protection
  { id: 'trademark', label: 'Brand Trademark Registration Filing', tier: 5, status: 'missing', critical: false },
  { id: 'service-agmt', label: 'Master Services Agreement (MSA)', tier: 5, status: 'missing', critical: false },
  { id: 'sla-template', label: 'SLA / Customer Terms of Service', tier: 5, status: 'missing', critical: false },
  { id: 'shareholders-agmt', label: 'Shareholders Agreement', tier: 5, status: 'missing', critical: true }
]

export const DOC_CATEGORIES = [
  { id: 1, name: 'Corporate & Structure', icon: 'Building2' },
  { id: 2, name: 'Core Financials', icon: 'Wallet' },
  { id: 3, name: 'Team & Human Capital', icon: 'Users' },
  { id: 4, name: 'Risk, Compliance & ESG', icon: 'ShieldCheck' },
  { id: 5, name: 'Legal & Protection', icon: 'Scale' },
]

export const CATEGORY_ACCESS = {
  seed: [1, 2],
  growth: [1, 2, 3],
  enterprise: [1, 2, 3, 4, 5],
}

export const CATEGORY_BREAKDOWN = [
  { label: 'Corporate', key: 'corporate', value: 100 },
  { label: 'Financial', key: 'financial', value: 45 },
  { label: 'Team', key: 'team', value: 30 },
  { label: 'Risk', key: 'risk', value: 60 },
  { label: 'Legal', key: 'legal', value: 80 },
]

/* --------------------------- Platform Admin Data --------------------------- */

export const platformKpis = {
  totalStartups: 247,
  totalRevenue: 184250,
  activeAgentRequests: 18,
  docsAwaitingVerification: 34,
}

export const platformCompanies = [
  { id: 'TC-001', name: 'Acme Innovations Ltd', founder: 'Chidi Okafor', country: 'Nigeria', currency: 'NGN', tier: 'Professional', mrr: 79, joined: '2025-11-02', docsVerified: 19, status: 'Active' },
  { id: 'TC-002', name: 'Northwind Labs', founder: 'Sarah Chen', country: 'United States', currency: 'USD', tier: 'Enterprise', mrr: 199, joined: '2025-09-14', docsVerified: 22, status: 'Active' },
  { id: 'TC-003', name: 'Bridgepoint UK', founder: 'James Whitfield', country: 'United Kingdom', currency: 'GBP', tier: 'Starter', mrr: 29, joined: '2025-12-20', docsVerified: 8, status: 'Pending' },
  { id: 'TC-004', name: 'Sydney Health Co', founder: 'Mia Patterson', country: 'Australia', currency: 'AUD', tier: 'Professional', mrr: 79, joined: '2025-10-08', docsVerified: 15, status: 'Active' },
  { id: 'TC-005', name: 'Maple Fintech', founder: 'Olivier Tremblay', country: 'Canada', currency: 'CAD', tier: 'Enterprise', mrr: 199, joined: '2025-08-30', docsVerified: 24, status: 'Active' },
  { id: 'TC-006', name: 'Berlin Mobility', founder: 'Lukas Wagner', country: 'Germany', currency: 'EUR', tier: 'Starter', mrr: 29, joined: '2026-01-05', docsVerified: 6, status: 'Pending' },
  { id: 'TC-007', name: 'Lion City AI', founder: 'Wei Tan', country: 'Singapore', currency: 'SGD', tier: 'Professional', mrr: 79, joined: '2025-12-11', docsVerified: 17, status: 'Active' },
  { id: 'TC-008', name: 'Cape Logistics', founder: 'Thabo Naidoo', country: 'South Africa', currency: 'ZAR', tier: 'Starter', mrr: 29, joined: '2026-01-18', docsVerified: 5, status: 'Pending' },
  { id: 'TC-009', name: 'Savannah Agri', founder: 'Amara Osei', country: 'Kenya', currency: 'KES', tier: 'Starter', mrr: 29, joined: '2025-11-27', docsVerified: 9, status: 'Active' },
  { id: 'TC-010', name: 'Mumbai Retail', founder: 'Priya Sharma', country: 'India', currency: 'INR', tier: 'Professional', mrr: 79, joined: '2025-10-22', docsVerified: 14, status: 'Active' },
  { id: 'TC-011', name: 'Gulf Maritime', founder: 'Khalid Al Mansouri', country: 'UAE', currency: 'AED', tier: 'Enterprise', mrr: 199, joined: '2025-09-03', docsVerified: 21, status: 'Suspended' },
  { id: 'TC-012', name: 'Polaris Ventures', founder: 'Elena Volkov', country: 'Other', currency: 'USD', tier: 'Starter', mrr: 29, joined: '2026-01-20', docsVerified: 3, status: 'Pending' },
]

export const platformDocQueue = [
  { id: 'GDOC-045', company: 'Acme Innovations Ltd', docName: 'CAC Certificate.pdf', uploadedBy: 'Chidi', date: '2026-01-14', status: 'Pending' },
  { id: 'GDOC-044', company: 'Northwind Labs', docName: 'Articles of Incorporation.pdf', uploadedBy: 'Sarah', date: '2026-01-13', status: 'Verified' },
  { id: 'GDOC-043', company: 'Bridgepoint UK', docName: 'CRN Filing.pdf', uploadedBy: 'James', date: '2026-01-12', status: 'Pending' },
  { id: 'GDOC-042', company: 'Sydney Health Co', docName: 'ABN Certificate.pdf', uploadedBy: 'Mia', date: '2026-01-11', status: 'Rejected' },
  { id: 'GDOC-041', company: 'Maple Fintech', docName: 'CRA Notice.pdf', uploadedBy: 'Olivier', date: '2026-01-10', status: 'Pending' },
  { id: 'GDOC-040', company: 'Berlin Mobility', docName: 'Handelsregister Extract.pdf', uploadedBy: 'Lukas', date: '2026-01-09', status: 'Verified' },
  { id: 'GDOC-039', company: 'Lion City AI', docName: 'BizFile Profile.pdf', uploadedBy: 'Wei', date: '2026-01-08', status: 'Pending' },
]

export const agentRequests = [
  { id: 'AG-021', company: 'Acme Innovations Ltd', document: 'SCUML Certificate', date: '2026-01-14', status: 'Open' },
  { id: 'AG-020', company: 'Bridgepoint UK', document: 'HMRC AML Registration', date: '2026-01-12', status: 'Assigned' },
  { id: 'AG-019', company: 'Cape Logistics', document: 'CIPC Certificate', date: '2026-01-10', status: 'Completed' },
  { id: 'AG-018', company: 'Mumbai Retail', document: 'MCA Filing', date: '2026-01-08', status: 'Open' },
  { id: 'AG-017', company: 'Gulf Maritime', document: 'CDD Registration', date: '2026-01-06', status: 'Assigned' },
]

export const countryDistribution = [
  { country: 'Nigeria', companies: 68, revenue: 5372, avgTier: 'Professional' },
  { country: 'United States', companies: 52, revenue: 10348, avgTier: 'Enterprise' },
  { country: 'United Kingdom', companies: 31, revenue: 2899, avgTier: 'Starter' },
  { country: 'Australia', companies: 22, revenue: 1738, avgTier: 'Professional' },
  { country: 'Canada', companies: 18, revenue: 3582, avgTier: 'Enterprise' },
  { country: 'Germany', companies: 19, revenue: 1387, avgTier: 'Starter' },
  { country: 'Singapore', companies: 15, revenue: 1185, avgTier: 'Professional' },
  { country: 'Other', companies: 22, revenue: 2915, avgTier: 'Starter' },
]

export const platformRevenueSeries = {
  Monthly: [14200, 15100, 16800, 17200, 18500, 19200, 20100, 21500, 22300, 23800, 24100, 25200],
  Quarterly: [46100, 53300, 64400, 73100],
  Yearly: [236900],
}

export const DATE_FORMATS = ['DD/MM/YYYY', 'MM/DD/YYYY']

export const TIMEZONES = [
  'Africa/Lagos (WAT)',
  'America/New_York (EST)',
  'America/Los_Angeles (PST)',
  'Europe/London (GMT)',
  'Europe/Berlin (CET)',
  'Asia/Singapore (SGT)',
  'Asia/Kolkata (IST)',
  'Asia/Dubai (GST)',
  'Australia/Sydney (AEDT)',
  'UTC',
]

/* --------------------------- Investor Directory --------------------------- */

export const platformInvestors = [
  { id: 'INV-001', name: 'David Okonkwo', fund: 'Halan Ventures', email: 'david@halan.vc', role: 'Partner', stageFocus: ['Seed', 'Series A'], checkSize: '$250k-1M', status: 'Verified', companiesRequested: 3 },
  { id: 'INV-002', name: 'Sarah Mitchell', fund: 'Orbit Capital', email: 'sarah@orbit.capital', role: 'Principal', stageFocus: ['Series A', 'Series B'], checkSize: '$1M-5M', status: 'Verified', companiesRequested: 5 },
  { id: 'INV-003', name: 'Michael Brennan', fund: 'Sequoia Africa', email: 'm.brennan@seq.africa', role: 'Associate', stageFocus: ['Seed'], checkSize: '$50k-250k', status: 'Pending Verification', companiesRequested: 2 },
  { id: 'INV-004', name: 'Aisha Mohammed', fund: 'Future Africa', email: 'aisha@future.africa', role: 'Partner', stageFocus: ['Pre-Seed', 'Seed'], checkSize: '$10k-50k', status: 'Verified', companiesRequested: 7 },
  { id: 'INV-005', name: 'Raj Patel', fund: 'Tiger Global', email: 'raj@tigerglobal.com', role: 'Analyst', stageFocus: ['Series B', 'Growth'], checkSize: '$5M+', status: 'Pending Verification', companiesRequested: 1 },
  { id: 'INV-006', name: 'Emma Larsson', fund: 'Northzone', email: 'emma@northzone.com', role: 'Principal', stageFocus: ['Series A', 'Series B'], checkSize: '$1M-5M', status: 'Suspended', companiesRequested: 2 },
]

/* ------------------------------ Agent Partners ------------------------------ */

export const agentPartners = [
  { id: 'AGT-01', name: 'Tunde Bakare & Associates', country: 'Nigeria', commissionRate: '12%', status: 'Active', requestsHandled: 24 },
  { id: 'AGT-02', name: 'Morgan Legal Partners', country: 'United States', commissionRate: '15%', status: 'Active', requestsHandled: 18 },
  { id: 'AGT-03', name: 'Whitfield & Co', country: 'United Kingdom', commissionRate: '14%', status: 'Active', requestsHandled: 11 },
  { id: 'AGT-04', name: 'Patterson Compliance Group', country: 'Australia', commissionRate: '12%', status: 'Active', requestsHandled: 8 },
  { id: 'AGT-05', name: 'Tremblay Corporate Services', country: 'Canada', commissionRate: '13%', status: 'Inactive', requestsHandled: 5 },
  { id: 'AGT-06', name: 'Wagner & Schmidt', country: 'Germany', commissionRate: '14%', status: 'Active', requestsHandled: 9 },
  { id: 'AGT-07', name: 'Lion City Compliance', country: 'Singapore', commissionRate: '13%', status: 'Active', requestsHandled: 7 },
  { id: 'AGT-08', name: 'Naidoo Legal Advisory', country: 'South Africa', commissionRate: '11%', status: 'Inactive', requestsHandled: 3 },
]

/* ------------------------- Public Companies (Discover) ------------------------- */

export const publicCompanies = [
  { id: 'TC-002', name: 'Northwind Labs', country: 'United States', industry: 'Technology / SaaS', pitch: 'AI-powered developer tools that reduce code review time by 60%.', readiness: 85, traction: '$2.4M ARR', currency: 'USD' },
  { id: 'TC-005', name: 'Maple Fintech', country: 'Canada', industry: 'Financial Services', pitch: 'Neobank for SMEs across North America with instant cross-border payments.', readiness: 92, traction: '$5.1M ARR', currency: 'CAD' },
  { id: 'TC-007', name: 'Lion City AI', country: 'Singapore', industry: 'Technology / SaaS', pitch: 'Computer vision platform for retail inventory management in APAC.', readiness: 78, traction: '$1.8M ARR', currency: 'SGD' },
  { id: 'TC-010', name: 'Mumbai Retail', country: 'India', industry: 'Retail & E-commerce', pitch: 'Omnichannel commerce platform for D2C brands in Tier 2/3 cities.', readiness: 71, traction: '$3.2M ARR', currency: 'INR' },
  { id: 'TC-009', name: 'Savannah Agri', country: 'Kenya', industry: 'Agriculture', pitch: 'Satellite-driven crop yield prediction for East African farms.', readiness: 64, traction: '$800k ARR', currency: 'KES' },
  { id: 'TC-004', name: 'Sydney Health Co', country: 'Australia', industry: 'Healthcare', pitch: 'Telemedicine platform connecting rural patients with specialists.', readiness: 80, traction: '$2.1M ARR', currency: 'AUD' },
]

export const ROLES = ['Partner', 'Analyst', 'Associate', 'Principal', 'Other']
export const STAGE_FOCI = ['Pre-Seed', 'Seed', 'Series A', 'Series B', 'Growth']
export const CHECK_SIZES = ['$10k-50k', '$50k-250k', '$250k-1M', '$1M-5M', '$5M+']

/* --------------------------- Founder Access Requests --------------------------- */

export const accessRequests = []

/* --------------------- Expanded Agent Requests (with timeline) --------------------- */

export const agentRequestTimeline = [
  { id: 'AG-021', agentName: 'Tunde Bakare & Associates', document: 'SCUML Certificate', company: 'Acme Innovations Ltd', date: '2026-01-14', status: 'Client Review', timeline: { assigned: '2026-01-14', draftUploaded: '2026-01-16', clientApproved: '2026-01-17' } },
  { id: 'AG-020', agentName: 'Whitfield & Co', document: 'HMRC AML Registration', company: 'Bridgepoint UK', date: '2026-01-12', status: 'Draft Ready', timeline: { assigned: '2026-01-12', draftUploaded: '2026-01-15', clientApproved: null } },
  { id: 'AG-019', agentName: 'Naidoo Legal Advisory', document: 'CIPC Certificate', company: 'Cape Logistics', date: '2026-01-10', status: 'Finalized', timeline: { assigned: '2026-01-10', draftUploaded: '2026-01-12', clientApproved: '2026-01-14' } },
  { id: 'AG-018', agentName: 'Morgan Legal Partners', document: 'MCA Filing', company: 'Mumbai Retail', date: '2026-01-08', status: 'Drafting', timeline: { assigned: '2026-01-08', draftUploaded: null, clientApproved: null } },
  { id: 'AG-017', agentName: 'Lion City Compliance', document: 'CDD Registration', company: 'Gulf Maritime', date: '2026-01-06', status: 'Assigned', timeline: { assigned: '2026-01-06', draftUploaded: null, clientApproved: null } },
]

/* --------------------- Platform Doc Queue (expanded statuses) --------------------- */

export const platformDocQueueExpanded = [
  { id: 'GDOC-045', company: 'Acme Innovations Ltd', docName: 'SCUML Certificate.pdf', uploadedBy: 'Agent', date: '2026-01-16', status: 'Draft Pending Client Review' },
  { id: 'GDOC-044', company: 'Northwind Labs', docName: 'Articles of Incorporation.pdf', uploadedBy: 'Founder', date: '2026-01-13', status: 'Verified' },
  { id: 'GDOC-043', company: 'Bridgepoint UK', docName: 'CRN Filing.pdf', uploadedBy: 'Founder', date: '2026-01-12', status: 'Awaiting Platform Verification' },
  { id: 'GDOC-042', company: 'Sydney Health Co', docName: 'ABN Certificate.pdf', uploadedBy: 'Founder', date: '2026-01-11', status: 'Closed - Rejected', rejectReason: 'Document is expired. Please upload a current version.' },
  { id: 'GDOC-041', company: 'Maple Fintech', docName: 'CRA Notice.pdf', uploadedBy: 'Founder', date: '2026-01-10', status: 'Pending' },
  { id: 'GDOC-040', company: 'Berlin Mobility', docName: 'Handelsregister Extract.pdf', uploadedBy: 'Founder', date: '2026-01-09', status: 'Verified' },
  { id: 'GDOC-039', company: 'Lion City AI', docName: 'BizFile Profile.pdf', uploadedBy: 'Agent', date: '2026-01-08', status: 'Awaiting Platform Verification' },
  { id: 'GDOC-038', company: 'Mumbai Retail', docName: 'MCA Filing.pdf', uploadedBy: 'Founder', date: '2026-01-07', status: 'Closed' },
]

export const DOC_STATUS_FILTERS = ['All', 'Pending', 'Draft Pending Client Review', 'Awaiting Platform Verification', 'Verified', 'Closed']